import {
    RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue,
  } from 'recoil';

export const tempState = atom({
    key: 'temp', // unique ID (with respect to other atoms/selectors)
    default: '', // default value (aka initial value)
  });

  export const tempLateEmp = atom({
    key: 'lateEmp', // unique ID (with respect to other atoms/selectors)
    default: [], // default value (aka initial value)
  });
  

  export const tempEndContract=atom({
    key:"EndContract",
    default: [],
  })